
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { extractMessageFromException } from '@/utils/helpers'
import analytics from '@/mixins.js/analytics'
import '@/utils/initValidationRules'

export default {
  components: { ValidationObserver, ValidationProvider },
  mixins: [analytics],
  transition: 'page',
  props: {
    subjects: {
      type: Array
    },
    hints: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contact: {
        subject: undefined
      },
      isLoading: false,
      invalid: true,
      sent: false,
      sentText: 'Thank you for requesting a quote! One of our Graphic Designers will be getting back to you within a few hours.',
      descriptions: {
        'matching-slides': 'How many slides do you need to adjust? What is your deadline? Give us some numbers, describe briefly your needs and we will be back with an offer.',
        'graphical-update': 'How many slides do you need to upgrade? What is your deadline? Give us some numbers, describe your needs briefly, and we will be back with an offer.',
        'pp-templates': 'How many slides the template should contain? What is your deadline? Give us some numbers, describe your needs briefly, and we will be back with an offer.',
        'pp-slides': 'How many slides do you need? What is your deadline? Give us some numbers, describe your needs briefly, and we will be back with an offer.',
        'vector-graphics': 'How many graphics do you need? Are they icons, diagrams or more complex infographics? What is your deadline? Give us some numbers, describe your needs briefly, and we will be back with an offer.',
        'pp-slides-design': 'How big is your team? Are there any special topics to be covered during the training? Describe your needs briefly, point dates that suit you, and we will be back with an offer.',
        'pp-data-visualization': 'How big is your team? Are there any special topics to be covered during the training? Describe your needs briefly, point dates that suit you, and we will be back with an offer.',
        'pp-1on1': 'Are you interested in any specific topic, or do you prefer us to guide you? Describe your needs briefly, and we will be back with an offer.',
        other: 'Your needs are beyond the scope of our services? Challenge us. We are growing with our clients and will take any new task related to visual presentations. Describe your needs briefly, and we will be back with an offer.'
      }
    }
  },
  methods: {
    setSubject (subject) {
      document.getElementById('services-form').scrollIntoView()
      this.contact.subject = subject
    },
    async onSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.isLoading = true
        try {
          this.trackEvent('Contact', 'Send message')
          await this.$backend.contact.post(
            this.contact
          )
          this.sent = true
        } catch (error) {
          this.$toast.error(extractMessageFromException(error))
        } finally {
          this.isLoading = false
        }
      }
    }
  }
}
